import styled from 'styled-components';

export const WebcamFrame = styled.div`
  display: block;
  position: relative;
  height: 0;
  padding-bottom: 56%;
  ${({ $disabled }) => $disabled && 'pointer-events: none;'}

  .webcam-holder,
  .webcam-guid-host {
    position: absolute;
    inset: 0;
  }

  .webcam-holder iframe,
  .webcam-guid-host iframe,
  [id^="webcam_holder"] iframe {
    position: absolute;
    inset: 0;
    width: 100% !important;
    height: 100% !important;
    border: 0;
  }
`;
